import { OpeningHoursList } from '../../../compositions/opening-hours/list/opening-hours-list';
import { useCurrentHealthProvider } from '../../../data/data/health-providers/use-current-health-provider';
import { useOpeningHoursItems } from '../../../data/data/opening-hours/use-opening-hours-items';
import { Content } from '../../../elements/content/content';

export function AdminOpeningHoursPage() {
  const { healthProvider } = useCurrentHealthProvider();

  const { data: openingHoursItemsData, loading: openingHoursItemsDataLoading } =
    useOpeningHoursItems({
      healthProviderId: healthProvider?.id,
    });

  return (
    <Content>
      <OpeningHoursList
        items={openingHoursItemsData}
        loading={openingHoursItemsDataLoading}
      />
    </Content>
  );
}
